import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import useAMRevamp from '~/hooks/useAMRevamp';
import { getHostingDisabled } from '~/utils/hosting/helpers';

type ProServicesCardPropOptions = {
  proServicesData?: {
    link: string;
  };
  isManagable?: boolean;
  hostingStatus?: string;
};

const ProServicesCard = ({
  proServicesData = undefined,
  isManagable = false,
  hostingStatus = 'inactive',
}: ProServicesCardPropOptions) => {
  const { t } = useTranslation('hosting');
  const { isAMRevamp } = useAMRevamp();
  const isDisabled = getHostingDisabled(hostingStatus);
  const isProServiceActionEnabled = isAMRevamp ? isManagable : isDisabled;

  return (
    <Grid item xs={12} className="xyz-nested">
      <Card>
        <CardHeader title={t('proServices.title')} />
        <Stack justifyContent="space-between" direction="row">
          <CardContent>
            <Typography variant="body2">
              {t('proServices.description')}
            </Typography>
          </CardContent>
          <CardContent sx={{ textAlign: 'right' }}>
            <Button
              variant="outlined"
              data-testid="btn-manage"
              href={proServicesData?.link || ''}
              disabled={isProServiceActionEnabled}
              target="_blank"
            >
              {t('proServices.action')}
            </Button>
          </CardContent>
        </Stack>
      </Card>
    </Grid>
  );
};

export default ProServicesCard;
